<status-badge
  *ngIf="status"
  [text]="status | warrantyStatus"
  [backgroundColor]="backgroundColor"
  [textColor]="textColor"
></status-badge>
